
export enum supportTopicId {
  SalesTeam,
  HelpDesk,
}
